import { DOMNodeProps } from "@/types";
import styles from "./Skeleton.module.scss";

export interface SkeletonProps extends DOMNodeProps {
  loading?: boolean;
}

export default function Skeleton({ loading, children, className, ...props }: SkeletonProps) {
  return loading === true || loading === undefined ? (
    <div
      className={`${styles.Skeleton} ${className}`}
      {...props}
    ></div>
  ) : (
    children
  );
}
